export const OrganizationMachineTabMenu = function () {
  return [
    {
      text: 'Tổ chức bộ máy',
      to: `/setting/org-machine/struct`
    },
    {
      text: 'Quản lý nhân sự',
      to: `/setting/org-machine/employee-manager`
    },
    {
      text: 'Quản lý KPI',
      to: `/setting/org-machine/kpi-manager`
    },
    {
      text: 'Quản lý lộ trình làm việc',
      to: '/setting/org-machine/rank-manager'
    }
  ];
}